import { useMutation, useQuery } from "react-query";
import {
  addValuation,
  editValuation,
  getAllRoundNames,
  getValuationDetails,
} from "../api/Valuation";
import { queryClient } from "./client";

export function useValuationDetails() {
  return useQuery({
    queryKey: "allValuationDetails",
    queryFn: getValuationDetails,
  });
}

export function useGetAllRoundNames() {
  return useQuery({
    queryKey: "getAllRoundNames",
    queryFn: getAllRoundNames,
  });
}

export function useAddValuation() {
  return useMutation({
    mutationKey: "addValuation",
    mutationFn: addValuation,
    onSuccess: () => {
      queryClient.invalidateQueries("allValuationDetails");
      queryClient.refetchQueries("allValuationDetails");
    },
    onError: () => {},
  });
}

export function useEditValuation() {
  return useMutation({
    mutationKey: "editValuation",
    mutationFn: editValuation,
    onSuccess: () => {
      queryClient.invalidateQueries("allValuationDetails");
      queryClient.refetchQueries("allValuationDetails");
    },
  });
}
